export enum RecoilKeys {
    Users = "d3b5dc4e-c531-41ea-aedf-896a09b77a13",
    Companies = "21577eaf-fcdb-4684-8f63-86b5eb775e2c",
    Jobs = "c51a2784-c23f-44bc-a797-c913cccc263e",
    Questions = "b3b73d18-6850-461f-acf7-5c5e25dbe7d3",
    OutcomeComment = "6d2b43d0-78b9-4e00-9bf8-175b31eac55c",
    ParentCompanies = "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    TaskSubmissionSearch = "f1a2b3c4-d5e6-7890-abcd-ef1234567891",
    TaskCounterSubmissionSearch = "a2b3c4d5-e6f7-8901-bcde-f12345678901",
    UserManagementSearch = "b3c4d5e6-f7a8-9012-cdef-123456789012",
    TasksListSearch = "c4d5e6f7-a8b9-0123-defa-234567890123",
    TaskCounterTemplateSearch = "d5e6f7a8-b9c0-1234-efab-345678901234",
    CompanyManagementSearch = "e6f7a8b9-c0d1-2345-fabc-456789012345",
};